import script from "./ChooseBumperModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChooseBumperModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChooseBumperModal.vue?vue&type=style&index=0&id=032087fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032087fc"]])

export default __exports__